(function () {
  function toggle(btn) {
    var panel = btn.nextElementSibling;
    if (!panel || !panel.classList.contains("watch_acc-panel")) return;

    var open = btn.getAttribute("aria-expanded") === "true";
    btn.setAttribute("aria-expanded", open ? "false" : "true");
    if (open) {
      panel.setAttribute("hidden", "");
    } else {
      panel.removeAttribute("hidden");
    }
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest(".watch_acc-btn");
    if (!btn || !btn.closest(".watch_pdp")) return;
    e.preventDefault();
    toggle(btn);
  });
})();
